import { Typography } from '@mui/material';
import { extract, isNullOrUndefined } from '@vy/utils';
import { useCallback } from 'react';
import { useFormContext } from 'react-hook-form';
import type { NewPlanAssignment } from '../plans-page-types/new-plan-assignment-schema';
import type { PlanAssignmentInput } from '../plans-page-types/plan-assignment-input-schema';
import { ContractDatePicker } from './ContractDatePicker';

type ContractSidebarLastStepProps = {
  title: string;
};

export const AssignPlanStepStartDate: React.FC<ContractSidebarLastStepProps> = ({ title }) => {
  const { watch, setValue } = useFormContext<PlanAssignmentInput, NewPlanAssignment>();
  const selectedCustomers = watch('selectedCustomers') ?? [];
  const selectedCustomersNames = extract(selectedCustomers, 'name');

  const onStartDateChanged = useCallback(
    (newStartDate: Date | undefined) => {
      if (isNullOrUndefined(newStartDate)) return;

      const utcNewStartDate = adjustUtcStartDate(newStartDate);
      setValue('contract.startDate', utcNewStartDate);
    },
    [setValue],
  );

  return (
    <>
      <div className="flex w-full items-center justify-start">
        <p className="text-xl font-medium">{title}</p>
      </div>
      <p className="text-sm">Define a starting date for this plan</p>
      <>
        <div className="flex flex-col px-5 space-y-4">
          {selectedCustomersNames.map((client, index) => (
            <div key={index} className="py-3">
              <Typography variant="body1" component="h6" style={{ textTransform: 'capitalize' }}>
                {client}
              </Typography>

              {selectedCustomers[index]?.contractsCount > 0 && (
                <span className="text-xs text-gray-400">
                  Customer Already has an active contract in place
                </span>
              )}
            </div>
          ))}
        </div>
        <ContractDatePicker
          date={watch('contract.startDate')}
          onSelect={onStartDateChanged}
          containerClassName="w-full px-5"
          withoutArrow
          fullWidth
        />
      </>
    </>
  );
};

function adjustUtcStartDate(date: Date) {
  const year = date.getFullYear();
  const month = date.getMonth();
  const day = date.getDate();
  const utcDateNumber = Date.UTC(year, month, day);

  return new Date(utcDateNumber);
}
